import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useHistory } from "react-router-dom";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../components/panel/panel.jsx";
import DataTable from "react-data-table-component";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import {
  GetAllSystemPackage,
  GetAllGenericListing,
  CreateSystempackage,
  CreateSystempackage1Dayes,
  UpdateSystempackage,
  GetFixedCurrencyListSuperadmin,
  GetAllCurrencyListSuperadmin,
  GetPackageDetailWithCurrencyListBySuperadmin,
} from "../../api/packageApi";
import swal from "sweetalert";
import Select from "react-select";
import { NumericFormat } from "react-number-format";

function Package() {
  let history = useHistory();
  const [selectedRows, setSelectedRows] = useState([]);
  const [packageaddeditmodalopen, setpackageaddeditmodalopen] = useState(false);
  const [packagename, setpackagename] = useState("");
  const [packagenameError, setpackagenameError] = useState("");

  const [monthlyprice, setmonthlyprice] = useState("");
  const [monthlypriceError, setmonthlypriceError] = useState("");

  const [annuallyprice, setAnnuallyprice] = useState("");
  const [annuallypriceError, setAnnuallypriceError] = useState("");

  const [systempackage, setSystempackage] = useState([]);
  const [packagecategory, setPackagecategory] = useState([]);
  const [dynamicQrCodeCount, setDynamicQrCodeCount] = useState("");
  const [dynamicQrCodeCountError, setDynamicQrCodeCountError] = useState("");
  const [bulkQrCodeCount, setbulkQrCodeCount] = useState("");
  const [bulkQrCodeCountError, setBulkQrCodeCountError] = useState("");
  const [monthlyCodeCount, setMonthlyCodeCount] = useState("");
  const [monthlyCodeCountError, setmonthlyCodeCountError] = useState("");
  const [subaccountCount, setSubaccountCount] = useState("");
  const [subaccountCountError, setSubaccountCountError] = useState("");
  const [dataStorageCount, setDataStorageCount] = useState("");
  const [dataStorageCountError, setDataStorageCountError] = useState("");
  const [noofchatuserCount, setNoofchatuserCount] = useState("");
  const [noofchatuserCountError, setNoofchatuserCountError] = useState("");
  const [staticCodeCount, setStaticCodeCount] = useState("");
  const [staticCodeCountError, setStaticCodeCountError] = useState("");

  const [personaldynamicQrCodeCount, setPersonaldynamicQrCodeCount] =
    useState("");
  const [personaldynamicQrCodeCountError, setPersonaldynamicQrCodeCountError] =
    useState("");

  const [selectpackageYearly, setselectpackageYearly] = useState("false");
  const [selectpackageCategory, setselectpackageCategory] = useState("");
  const [selectpackageCategoryError, setselectpackageCategoryError] =
    useState("");

  const [IsWeb, setIsWeb] = useState(true);
  const [IsCustom, setIsCustom] = useState(false);
  const [ChatEnabled, setChatEnabled] = useState(true);
  const [AutoRenewal, setAutoRenewal] = useState(true);
  const [SSLCertificate, setSSLCertificate] = useState(true);
  const [AdvanceQrCodeSearch, setAdvanceQrCodeSearch] = useState(true);
  const [QrCodeSaveInWallet, setQrCodeSaveInWallet] = useState(true);
  const [QrCodeCategoryManaged, setQrCodeCategoryManaged] = useState(true);
  const [ExportQrCode, setExportQrCode] = useState(true);
  const [EmailSupport, setEmailSupport] = useState(true);
  const [IndividualSupport, setIndividualSupport] = useState(true);
  const [IndividualPhoneSupport, setIndividualPhoneSupport] = useState(true);
  const [WhiteLabelling, setWhiteLabelling] = useState(true);
  const [YourBranding, setYourBranding] = useState(true);
  const [SystempackageID, setSystempackageID] = useState("");

  const [isdisabled, setisdisabled] = useState(false);
  const [CurrencyList, setCurrencyList] = useState([]);
  const [FixCurrencyList, setFixCurrencyList] = useState([]);
  const [IsMonthly, setIsMonthly] = useState(true);
  const [IsYearly, setIsYearly] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedOptionError, setSelectedOptionError] = useState("");
  const [selectedcurrency, setSelectedcurrency] = useState([]);

  const toggleQrCodeModal = () => {
    systempackageclere();
    setpackageaddeditmodalopen(!packageaddeditmodalopen);
  };

  useEffect(() => {
    console.log("state", selectedRows);
  }, [selectedRows]);
  useEffect(() => {
    let checkLogin = localStorage.getItem("loginUserID");
    if (
      checkLogin === "" ||
      checkLogin === "" ||
      checkLogin === undefined ||
      checkLogin === null
    ) {
      history.push("/Login");
    } else {
      getAllSystemPackageDetail();
      getAllGenericListing();
      getFixedCurrencyListSuperadmin();
      // getAllCurrencyListSuperadmin();
    }
  }, []);

  const getAllSystemPackageDetail = async () => {
    let response = await GetAllSystemPackage();
    if (response !== null) {
      response?.forEach((item, index) => {
        item.sr = index + 1;
      });
      setSystempackage(response);
    } else {
      setSystempackage([]);
    }
  };
  const getAllGenericListing = async () => {
    let response = await GetAllGenericListing("packagecategory");
    setPackagecategory(response);
  };
  const getFixedCurrencyListSuperadmin = async () => {
    let response = await GetFixedCurrencyListSuperadmin();
    setFixCurrencyList(response);
  };
  // const getAllCurrencyListSuperadmin = async () => {
  //   let response = await GetAllCurrencyListSuperadmin("Currency");
  //   setCurrencyList(response);
  // };
  const handleChange = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  const columns = useMemo(
    () => [
      {
        name: "Sr.no",
        selector: (row, index) => row?.sr,
        sortable: false,
        grow: 1,
      },
      {
        name: "Package name",
        selector: (row) => row?.packageName,
        sortable: true,
      },
      {
        name: "Price",
        selector: (row) => row?.priceValue,
        sortable: false,
        style: (row) => ({ display: "block" }),
        cell: (row) => {
          {
            return row?.currencyList?.length > 0 ? (
              row?.currencyList?.map((item, index) => {
                return (
                  <div>
                    <span className="smallroundbuttonrow">
                      <div className="smallroundbutton"></div>
                      <p className="pricebuttontext">
                        {item?.label} {""}
                        {"( "}
                        {item?.otherName}
                        {item?.priceValue} {" )"}
                      </p>
                    </span>
                  </div>
                );
              })
            ) : (
              <span>N/A</span>
            );
          }
        },
      },
      {
        name: "Web / Mobile",
        selector: (row) => (row?.isWeb === true ? "Web" : "Mobile"),
        // selector: (row) => {
        //   return row?.isWeb ? (
        //     <span className="mb-0 ">{"Web"}</span>
        //   ) : (
        //     <>
        //       {" "}
        //       <span className="mb-0">{"Mobile"}</span>
        //     </>
        //   );
        // },
        sortable: true,
      },
      {
        name: "Custom / Regular",
        selector: (row) => (row?.isCustom === true ? "Custom" : "Regular"),
        // selector: (row) => {
        //   return row?.isCustom ? (
        //     <span className="mb-0">{"Custom"}</span>
        //   ) : (
        //     <>
        //       {" "}
        //       <span className="mb-0">{"Regular"}</span>
        //     </>
        //   );
        // },
        sortable: true,
      },
      {
        name: "Yearly/Monthly",
        selector: (row) => (row?.isMonthly === true ? "Monthly" : "Yearly"),
        sortable: true,
      },
      {
        name: "Storage capacity",
        sortable: false,
        cell: (row) => {
          let GB = "";
          if (row.dataStorageCount) {
            let Intvalue = parseFloat(row.dataStorageCount);
            GB = parseFloat((Intvalue) / 1000000000).toFixed(2);
          }
          return (

            <div>
              {
                (row.dataStorageCount === -1 || row.dataStorageCount === "-1") ? <span className="mb-0">{"Unlimited"}</span>
                  : <span className="mb-0">{GB}</span>

              }

            </div>
          );
        },
      },
      {
        name: "Action",
        cell: (row) => {
          return (
            <div>
              <button
                onClick={() => {
                  editsystemdata(row);
                }}
                type="button"
                className="btn btn-primary btn-sm mr-2"
              >
                <i className="ion ion-md-create "></i>
              </button>
            </div>
          );
        },
      },
    ],
    []
  );

  const submitSystempackage = async () => {
    let loginid = localStorage.getItem("loginUserID");

    if (
      packagename === null ||
      packagename === "" ||
      packagename === undefined
    ) {
      setpackagenameError("Please Enter Package Name");
      return true;
    }
    if (
      selectpackageCategory === null ||
      selectpackageCategory === "" ||
      selectpackageCategory === undefined
    ) {
      setselectpackageCategoryError("Please Select Category");
      return true;
    }
    if (
      selectedOption === null ||
      selectedOption === "" ||
      selectedOption === undefined
    ) {
      setSelectedOptionError("Please Select Currency");
      return true;
    } else {
      if (selectedcurrency.length > 0) {
        let tempselectedcurrency = [...selectedcurrency];
        let temp = tempselectedcurrency.find(
          (x) =>
            x.priceValue === "" ||
            x.priceValue === null ||
            x.priceValue === undefined
        );
        if (temp !== null && temp !== "" && temp !== undefined) {
          let index = tempselectedcurrency.findIndex(
            (obj) => obj?.value === temp?.value
          );
          tempselectedcurrency[index].priceValueError = "Please Enter Price";
          setSelectedcurrency(tempselectedcurrency);
          return;
        }
      } else {
        setSelectedOptionError("Please Select Currency");
        return true;
      }
    }
    let tempselectedcurrency = [...selectedcurrency];
    let finalcurrencylist = [];
    if (tempselectedcurrency) {
      tempselectedcurrency.map((item) => {
        let CurrencyPriceDto = {
          CurrencyID: item?.value,
          Price: item?.priceValue,
        };
        finalcurrencylist.push(CurrencyPriceDto);
      });
    }
    let bytes = "";
    if (dataStorageCount) {
      let Intvalue = parseFloat(dataStorageCount);
      bytes = parseFloat((Intvalue) * 1000000000).toFixed(0);
    }
    let body = {
      _id: SystempackageID,
      categoryId: selectpackageCategory,
      packageName: packagename,
      isCustom: IsCustom,
      isWeb: IsWeb,
      isAutoRenewal: AutoRenewal,
      articalSavingCount: dynamicQrCodeCount ? dynamicQrCodeCount : "-1",
      apDynamicQrCodeCount: dynamicQrCodeCount ? dynamicQrCodeCount : "-1",
      bulkQrCodeCount: bulkQrCodeCount ? bulkQrCodeCount : "-1",
      dynamicQrCodeCount: personaldynamicQrCodeCount
        ? personaldynamicQrCodeCount
        : "-1",
      staticQrCodeCount: staticCodeCount ? staticCodeCount : "-1",
      dataStorageCount: dataStorageCount ? bytes : "-1",
      monthlyScanCount: monthlyCodeCount ? monthlyCodeCount : "-1",
      subAccountCount: subaccountCount ? subaccountCount : "-1",
      noOfChatUser: noofchatuserCount ? noofchatuserCount : "-1",
      isChatEnabled: IsWeb ? ChatEnabled : false,
      isSSLCertificate: IsWeb ? SSLCertificate : false,
      isAdvanceQrCodeSearch: IsWeb ? AdvanceQrCodeSearch : false,
      isQrCodeSaveInWallet: IsWeb ? QrCodeSaveInWallet : false,
      isQrCodeCategoryManaged: IsWeb ? QrCodeCategoryManaged : false,
      isExportQrCode: IsWeb ? ExportQrCode : false,
      isEmailSupport: IsWeb ? EmailSupport : false,
      isIndividualSupport: IsWeb ? IndividualSupport : false,
      isIndividualPhoneSupport: IsWeb ? IndividualPhoneSupport : false,
      isWhiteLabelling: IsWeb ? WhiteLabelling : false,
      isYourBranding: IsWeb ? YourBranding : false,
      createdBy: loginid,
      updatedBy: loginid,
      PackagePriceList: finalcurrencylist,
      IsMonthly: IsMonthly,
    };
    if (
      SystempackageID !== "" &&
      SystempackageID !== undefined &&
      SystempackageID !== null
    ) {
      let response = await UpdateSystempackage(
        JSON.stringify(body),
        SystempackageID
      );
      if (
        response?._id !== null &&
        response?._id !== "" &&
        response?._id !== null
      ) {
        getAllSystemPackageDetail();
        systempackageclere();
        setpackageaddeditmodalopen(false);
        swal("successfully", "update package successfully.", "success");
      } else {
        swal("sorry!", "package not update.", "error");
      }
    } else {
      let response = await CreateSystempackage(JSON.stringify(body));
      if (
        response?._id !== null &&
        response?._id !== "" &&
        response?._id !== null
      ) {
        getAllSystemPackageDetail();
        systempackageclere();
        setpackageaddeditmodalopen(false);
        swal("successfully", "create package successfully.", "success");
      } else {
        swal("sorry!", "package not create.", "error");
      }
    }
  };
  const submitSystempackage1Days = async () => {
    let loginid = localStorage.getItem("loginUserID");

    if (
      packagename === null ||
      packagename === "" ||
      packagename === undefined
    ) {
      setpackagenameError("Please Enter Package Name");
      return true;
    }
    if (
      selectpackageCategory === null ||
      selectpackageCategory === "" ||
      selectpackageCategory === undefined
    ) {
      setselectpackageCategoryError("Please Select Category");
      return true;
    }
    if (
      selectedOption === null ||
      selectedOption === "" ||
      selectedOption === undefined
    ) {
      setSelectedOptionError("Please Select Currency");
      return true;
    } else {
      if (selectedcurrency.length > 0) {
        let tempselectedcurrency = [...selectedcurrency];
        let temp = tempselectedcurrency.find(
          (x) =>
            x.priceValue === "" ||
            x.priceValue === null ||
            x.priceValue === undefined
        );
        if (temp !== null && temp !== "" && temp !== undefined) {
          let index = tempselectedcurrency.findIndex(
            (obj) => obj?.value === temp?.value
          );
          tempselectedcurrency[index].priceValueError = "Please Enter Price";
          setSelectedcurrency(tempselectedcurrency);
          return;
        }
      } else {
        setSelectedOptionError("Please Select Currency");
        return true;
      }
    }
    let tempselectedcurrency = [...selectedcurrency];
    let finalcurrencylist = [];
    if (tempselectedcurrency) {
      tempselectedcurrency.map((item) => {
        let CurrencyPriceDto = {
          CurrencyID: item?.value,
          Price: item?.priceValue,
        };
        finalcurrencylist.push(CurrencyPriceDto);
      });
    }
    let bytes = "";
    if (dataStorageCount) {
      let Intvalue = parseFloat(dataStorageCount);
      bytes = parseFloat((Intvalue) * 1000000000).toFixed(0);
    }
    let body = {
      _id: SystempackageID,
      categoryId: selectpackageCategory,
      packageName: packagename,
      isCustom: IsCustom,
      isWeb: IsWeb,
      isAutoRenewal: AutoRenewal,
      articalSavingCount: dynamicQrCodeCount ? dynamicQrCodeCount : "-1",
      apDynamicQrCodeCount: dynamicQrCodeCount ? dynamicQrCodeCount : "-1",
      bulkQrCodeCount: bulkQrCodeCount ? bulkQrCodeCount : "-1",
      dynamicQrCodeCount: personaldynamicQrCodeCount
        ? personaldynamicQrCodeCount
        : "-1",
      staticQrCodeCount: staticCodeCount ? staticCodeCount : "-1",
      // dataStorageCount: dataStorageCount ? dataStorageCount : "-1",
      dataStorageCount: dataStorageCount ? bytes : "-1",
      monthlyScanCount: monthlyCodeCount ? monthlyCodeCount : "-1",
      subAccountCount: subaccountCount ? subaccountCount : "-1",
      noOfChatUser: noofchatuserCount ? noofchatuserCount : "-1",
      isChatEnabled: IsWeb ? ChatEnabled : false,
      isSSLCertificate: IsWeb ? SSLCertificate : false,
      isAdvanceQrCodeSearch: IsWeb ? AdvanceQrCodeSearch : false,
      isQrCodeSaveInWallet: IsWeb ? QrCodeSaveInWallet : false,
      isQrCodeCategoryManaged: IsWeb ? QrCodeCategoryManaged : false,
      isExportQrCode: IsWeb ? ExportQrCode : false,
      isEmailSupport: IsWeb ? EmailSupport : false,
      isIndividualSupport: IsWeb ? IndividualSupport : false,
      isIndividualPhoneSupport: IsWeb ? IndividualPhoneSupport : false,
      isWhiteLabelling: IsWeb ? WhiteLabelling : false,
      isYourBranding: IsWeb ? YourBranding : false,
      createdBy: loginid,
      updatedBy: loginid,
      PackagePriceList: finalcurrencylist,
      IsMonthly: IsMonthly,
    };

    console.log("body", JSON.stringify(body));
    if (
      SystempackageID !== "" &&
      SystempackageID !== undefined &&
      SystempackageID !== null
    ) {
      let response = await UpdateSystempackage(
        JSON.stringify(body),
        SystempackageID
      );
      if (
        response?._id !== null &&
        response?._id !== "" &&
        response?._id !== null
      ) {
        getAllSystemPackageDetail();
        systempackageclere();
        setpackageaddeditmodalopen(false);
        swal("successfully", "update package successfully.", "success");
      } else {
        swal("sorry!", "package not update.", "error");
      }
    } else {
      let response = await CreateSystempackage1Dayes(JSON.stringify(body));
      if (
        response?._id !== null &&
        response?._id !== "" &&
        response?._id !== null
      ) {
        getAllSystemPackageDetail();
        systempackageclere();
        setpackageaddeditmodalopen(false);
        swal("successfully", "create package successfully.", "success");
      } else {
        swal("sorry!", "package not create.", "error");
      }
    }
  };

  const systempackageclere = () => {
    setSystempackageID("");
    setselectpackageCategory("");
    setpackagename("");
    setmonthlyprice("");
    setAnnuallyprice("");
    setAnnuallypriceError("");
    setmonthlypriceError("");
    setIsCustom(false);
    setIsWeb(true);
    // setselectpackageYearly(true);
    setAutoRenewal(true);
    setDynamicQrCodeCount("");
    setbulkQrCodeCount("");
    setPersonaldynamicQrCodeCount("");
    setStaticCodeCount("");
    setDataStorageCount("");
    setMonthlyCodeCount("");
    setSubaccountCount("");
    setChatEnabled(true);
    setNoofchatuserCount("");
    setSSLCertificate(true);
    setAdvanceQrCodeSearch(true);
    setQrCodeSaveInWallet(true);
    setQrCodeCategoryManaged(true);
    setExportQrCode(true);
    setEmailSupport(true);
    setIndividualSupport(true);
    setIndividualPhoneSupport(true);
    setWhiteLabelling(true);
    setYourBranding(true);
    setSelectedcurrency([]);
    setSelectedOption(null);
    setSelectedOptionError("");
    setisdisabled(false);
  };

  const editsystemdata = async (item) => {
    try {
      if (item?._id !== null && item?._id !== "" && item?._id !== undefined) {
        let response = await GetPackageDetailWithCurrencyListBySuperadmin(
          item?._id
        );
        if (response !== null && response !== "" && response !== undefined) {
          setSelectedcurrency(
            response?.currencyList ? response?.currencyList : []
          );

          response?.currencyList.forEach((item, index) => {
            let C_ID = item?.currencyID;
            let priceid = item?.value;
            item.value = C_ID;
            item.currencyID = priceid;
          });
          setSelectedOption(
            response?.currencyList ? response?.currencyList : []
          );

          if (item?.isMonthly === true) {
            setIsMonthly(true);
            setIsYearly(false);
          } else {
            setIsMonthly(false);
            setIsYearly(true);
          }
          setisdisabled(true);
          setSystempackageID(item?._id);
          setselectpackageCategory(item?.categoryId);
          setpackagename(item?.packageName);
          // setmonthlyprice(item?.monthlyPrice ? item?.monthlyPrice.toString() : "0");
          // setAnnuallyprice(
          //   item?.annuallyPrice ? item?.annuallyPrice.toString() : "0"
          // );
          if (item?.isCustom === false) {
            setIsCustom(item?.isCustom);
          } else if (item?.isCustom === true) {
            setIsCustom(item?.isCustom);
          } else {
            setIsCustom(false);
          }
          let GB = "";
          if (item?.dataStorageCount) {
            let Intvalue = parseFloat(item?.dataStorageCount);
            GB = parseFloat((Intvalue) / 1000000000).toFixed(2);
          }
          setIsWeb(item?.isWeb);
          // setselectpackageYearly(item?.isMonthly === true ? "true" : "false");
          setAutoRenewal(item?.isAutoRenewal);
          setDynamicQrCodeCount(item?.apDynamicQrCodeCount.toString() === "-1" ? "" : item?.apDynamicQrCodeCount.toString());
          setbulkQrCodeCount(item?.bulkQrCodeCount.toString() === "-1" ? "" : item?.bulkQrCodeCount.toString());
          setPersonaldynamicQrCodeCount(item?.dynamicQrCodeCount.toString() === "-1" ? "" : item?.dynamicQrCodeCount.toString());
          setStaticCodeCount(item?.staticQrCodeCount.toString() === "-1" ? "" : item?.staticQrCodeCount.toString());
          setDataStorageCount(GB ? GB : 0);
          setMonthlyCodeCount(item?.monthlyScanCount.toString() === "-1" ? "" : item?.monthlyScanCount.toString());
          setSubaccountCount(item?.subAccountCount.toString() === "-1" ? "": item?.subAccountCount.toString());
          setChatEnabled(item?.isChatEnabled);
          setNoofchatuserCount(item?.noOfChatUser.toString() === "-1" ? "" : item?.noOfChatUser.toString());
          setSSLCertificate(item?.isSSLCertificate);
          setAdvanceQrCodeSearch(item?.isAdvanceQrCodeSearch);
          setQrCodeSaveInWallet(item?.isQrCodeSaveInWallet);
          setQrCodeCategoryManaged(item?.isQrCodeCategoryManaged);
          setExportQrCode(item?.isExportQrCode);
          setEmailSupport(item?.isEmailSupport);
          setIndividualSupport(item?.isIndividualSupport);
          setIndividualPhoneSupport(item?.isIndividualPhoneSupport);
          setWhiteLabelling(item?.isWhiteLabelling);
          setYourBranding(item?.isYourBranding);
          setpackageaddeditmodalopen(true);
        }
      }
    } catch (error) {
      console.log("error====>", error);
    }
  };

  const onChangecurrency = (item) => {
    if (isdisabled === false) {
      let olddata = [...selectedcurrency];
      if (item?.action === "select-option") {
        item.option.priceValue = "";
        olddata.push(item?.option);
        setSelectedcurrency(olddata);
      } else if (item?.action === "remove-value") {
        let data = olddata.filter((x) => x.value !== item?.removedValue?.value);
        setSelectedcurrency(data);
      } else if (item?.action === "clear") {
        setSelectedcurrency([]);
      }
    }
  };
  const createCurrencyUI = () => {
    if (
      selectedcurrency !== null &&
      selectedcurrency !== "" &&
      selectedcurrency !== undefined &&
      selectedcurrency.length > 0
    ) {
      return selectedcurrency.map((el, i) => {
        return (
          <>
            <div
              className={
                selectedcurrency.length === 1
                  ? "col-xl-12 col-lg-12 mt-2"
                  : selectedcurrency.length === 2
                    ? "col-xl-6 col-lg-6 mt-2"
                    : "col-xl-4 col-lg-4 mt-2"
              }
            >
              <label htmlFor="exampleInputEmail1">
                <h5 className="mb-0">
                  {el?.label} {"(" + el?.otherName + ")"}
                </h5>
              </label>
              {/* <input
                disabled={isdisabled}
                type="text"
                maxlength="20"
                className="form-control mb-2"
                placeholder="Please Enter No Of Chat User"
                value={el?.priceValue}
                // id={item?._id}
                onChange={OnchangedPrice(i)}
              /> */}
              <NumericFormat
                disabled={isdisabled}
                thousandSeparator={true}
                className="form-control mb-2"
                placeholder={`${el?.label} Price`}
                decimalScale={2}
                fixedDecimalScale={false}
                value={el?.priceValue}
                onValueChange={OnchangedPrice(i)}
              />
              {el?.priceValueError?.length > 0 ? (
                <span style={{ color: "red", marginLeft: 6 }}>
                  {el?.priceValueError}
                </span>
              ) : (
                <></>
              )}
            </div>
          </>
        );
      });
    }
  };
  const OnchangedPrice = (i) => (e) => {
    if (
      selectedcurrency !== null &&
      selectedcurrency !== "" &&
      selectedcurrency !== undefined &&
      isdisabled == false
    ) {
      let selectedcurrencyTemp = [...selectedcurrency];
      selectedcurrencyTemp[i].priceValue = e.floatValue;
      selectedcurrencyTemp[i].priceValueError = "";
      setSelectedcurrency(selectedcurrencyTemp);
    }
  };

  return (
    <div>
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <a href="/home">Home</a>
          </li>
          <li className="breadcrumb-item active">Package</li>
        </ol>
        <h1 className="page-header">Packages</h1>
        <div className="row d-flex justify-content-end mb-2">
          <div className="col-md-12 row justify-content-end">
            <button
              onClick={toggleQrCodeModal}
              type="button"
              className="btns btn btn-primary search-btn mr-2 mb-1"
            >
              <i className="fas fa-lg fa-fw m-r-5 fa-plus-square icon"></i>
              Add new
            </button>
          </div>
        </div>
        <Panel className="mt-2">
          <PanelHeader>
            <div className="d-md-flex align-items-center">
              <h4 className="mb-0 text-light">Package list</h4>
            </div>
          </PanelHeader>
          <PanelBody>
            <DataTable
              pagination
              data={systempackage}
              columns={columns}
              sortIcon={
                <i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>
              }
              selectableRows
              onSelectedRowsChange={handleChange}
            />
          </PanelBody>
        </Panel>
      </div>
      <Modal
        isOpen={packageaddeditmodalopen}
        toggle={packageaddeditmodalopen}
        className="modal-size"
      >
        <ModalHeader toggle={toggleQrCodeModal} className="modalheader">
          <h4 className="text-white mb-0">
            {SystempackageID.length === 0 ? "Add Package " : " Edit Package "}
          </h4>
        </ModalHeader>
        <ModalBody>
          <div className="form-group">
            <div className="row">
              <div className="col-xl-6 col-lg-6">
                <div className="mt-2">
                  <input
                    disabled={isdisabled}
                    type="checkbox"
                    value=""
                    id="IsWeb"
                    checked={IsWeb}
                    onChange={(e) => {
                      setNoofchatuserCount("");
                      setMonthlyCodeCount("");
                      setbulkQrCodeCount("")
                      setSubaccountCount("");
                      setStaticCodeCount("")
                      setPersonaldynamicQrCodeCount("");
                      setIsWeb(true)
                      // setIsWeb(e.target.checked);
                    }}
                  />
                  <label htmlFor="IsWeb" className="ml-2">
                    {" "}
                    Web
                  </label>
                </div>
              </div>
              {/* <div className="col-xl-6 col-lg-6">
                <div className="mt-2">
                  <input
                    disabled={isdisabled}
                    type="checkbox"
                    value=""
                    id="IsMobile"
                    checked={IsWeb === false ? true : false}
                    onChange={(e) => {
                      setNoofchatuserCount("");
                      setMonthlyCodeCount("");
                      setbulkQrCodeCount("")
                      setSubaccountCount("");
                      setStaticCodeCount("")
                      setPersonaldynamicQrCodeCount("");
                      setIsWeb(false)
                      // setIsWeb(e.target.checked);
                    }}
                  />
                  <label htmlFor="IsMobile" className="ml-2">
                    {" "}
                    Mobile
                  </label>
                </div>
              </div> */}

              <div className="col-xl-12 col-lg-12">
                <label htmlFor="exampleInputEmail1">
                  <h5 className="mb-0">Package name</h5>
                </label>

                <input
                  type="text"
                  maxlength="30"
                  className="form-control mb-2"
                  placeholder="Please Enter package name "
                  value={packagename}
                  onChange={(event) => {
                    setpackagenameError("");
                    setpackagename(event.target.value);
                  }}
                />

                {/* <p
                  style={{
                    fontSize: 12,
                    color: "red",
                    marginTop: "7px",
                    marginLeft: "10px",
                  }}
                >
                  {packagename?.length}/30
                </p> */}
                {packagenameError.length > 0 && (
                  <span style={{ color: "red", marginLeft: 6 }}>
                    {packagenameError}
                  </span>
                )}
              </div>
              <div className="col-xl-12 col-lg-12">
                <label htmlFor="exampleInputEmail1">
                  <h5 className="mb-0">Package Category</h5>
                </label>
                <div className="searchForm">
                  <select
                    disabled={isdisabled}
                    className="default-select2 form-control mb-2"
                    onChange={(e) => {
                      setselectpackageCategoryError("");
                      setselectpackageCategory(e.target.value);
                    }}
                  >
                    <option value="" selected={selectpackageCategory === ""}>
                      select package Category
                    </option>
                    {packagecategory.map((item) => {
                      return (
                        <option
                          value={item?.value}
                          selected={selectpackageCategory === item?.value}
                        >
                          {item?.text}
                        </option>
                      );
                    })}
                  </select>
                  {selectpackageCategoryError.length > 0 && (
                    <span style={{ color: "red", marginLeft: 6 }}>
                      {selectpackageCategoryError}
                    </span>
                  )}
                </div>
              </div>

              <div className="col-xl-6 col-lg-6">
                <div className="mt-2">
                  <input
                    disabled={isdisabled}
                    type="checkbox"
                    value=""
                    id="IsMonthly"
                    checked={IsMonthly}
                    onChange={(e) => {
                      setIsMonthly(true);
                      setIsYearly(false);
                    }}
                  />
                  <label htmlFor="IsMonthly" className="ml-2">
                    {" "}
                    Monthly
                  </label>
                </div>
              </div>

              <div className="col-xl-6 col-lg-6">
                <div className="mt-2">
                  <input
                    disabled={isdisabled}
                    type="checkbox"
                    value=""
                    id="IsYearly"
                    checked={IsYearly}
                    onChange={(e) => {
                      setIsMonthly(false);
                      setIsYearly(true);
                    }}
                  />
                  <label htmlFor="IsSSLCertificate" className="ml-2">
                    {" "}
                    Yearly
                  </label>
                </div>
              </div>
              <div className="col-xl-12 col-lg-12">
                <label htmlFor="exampleInputEmail1">
                  <h5 className="mb-0">Currency</h5>
                </label>
                <div className="searchForm">
                  <Select
                    disabled={isdisabled}
                    // defaultValue={selectedOption}
                    value={selectedOption}
                    onChange={(e, index) => {
                      if (isdisabled === false) {
                        setSelectedOption(e);
                        setSelectedOptionError("");
                        onChangecurrency(index);
                      }
                    }}
                    options={FixCurrencyList}
                    isMulti
                  />
                  {selectedOptionError.length > 0 && (
                    <span style={{ color: "red", marginLeft: 6 }}>
                      {selectedOptionError}
                    </span>
                  )}
                </div>
              </div>
              {createCurrencyUI()}
              {/* {selectedOption !== null &&
              selectedOption !== "" &&
              selectedOption !== undefined ? (
                selectedOption.map((item, index) => {
                  return (
                  
                  );
                })
              ) : (
                <></>
              )} */}
              {
                IsWeb ?
                  <div className="col-xl-6 col-lg-6">
                    <label htmlFor="exampleInputEmail1">
                      <h5 className="mb-0">No Of Chat User</h5>
                    </label>
                    <input
                      disabled={isdisabled}
                      type="text"
                      maxlength="20"
                      className="form-control mb-2"
                      placeholder="Please Enter No Of Chat User"
                      value={noofchatuserCount}
                      onChange={(event) => {
                        setNoofchatuserCountError("");
                        setNoofchatuserCount(event.target.value);
                      }}
                    />
                    {/* <p
                  style={{
                    fontSize: 12,
                    color: "red",
                    marginTop: "7px",
                    marginLeft: "10px",
                  }}
                >
                  {noofchatuserCount?.length}/20
                </p> */}
                    {noofchatuserCountError.length > 0 && (
                      <span style={{ color: "red", marginLeft: 6 }}>
                        {noofchatuserCountError}
                      </span>
                    )}
                  </div>
                  :
                  <>
                  </>
              }
              {
                IsWeb ?
                  <div className="col-xl-6 col-lg-6">
                    <label htmlFor="exampleInputEmail1">
                      <h5 className="mb-0">Monthly Scan Count</h5>
                    </label>
                    <input
                      disabled={isdisabled}
                      type="text"
                      maxlength="20"
                      className="form-control mb-2"
                      placeholder="Please Enter Monthly Scan Count"
                      value={monthlyCodeCount}
                      onChange={(event) => {
                        setmonthlyCodeCountError("");
                        setMonthlyCodeCount(event.target.value);
                      }}
                    />
                    {/* <p
                  style={{
                    fontSize: 12,
                    color: "red",
                    marginTop: "7px",
                    marginLeft: "10px",
                  }}
                >
                  {monthlyCodeCount?.length}/20
                </p> */}
                    {monthlyCodeCountError.length > 0 && (
                      <span style={{ color: "red", marginLeft: 6 }}>
                        {monthlyCodeCountError}
                      </span>
                    )}
                  </div>
                  :
                  <>
                  </>
              }

              {/* <div className="col-xl-6 col-lg-6">
                <label htmlFor="exampleInputEmail1">
                  <h5 className="mb-0">Monthly Price</h5>
                </label>
                <input
                  disabled={isdisabled}
                  type="text"
                  maxlength="20"
                  className="form-control mb-2"
                  placeholder="Please Enter Monthly Price"
                  value={monthlyprice}
                  onChange={(event) => {
                    setmonthlypriceError("");
                    setmonthlyprice(event.target.value.replace(/\D/g, ""));
                  }}
                />
                {monthlypriceError.length > 0 && (
                  <span style={{ color: "red", marginLeft: 6 }}>
                    {monthlypriceError}
                  </span>
                )}
              </div>
              <div className="col-xl-6 col-lg-6">
                <label htmlFor="exampleInputEmail1">
                  <h5 className="mb-0">Annually Price</h5>
                </label>
                <input
                  type="text"
                  disabled={isdisabled}
                  maxlength="20"
                  className="form-control mb-2"
                  placeholder="Please Enter Annually Price"
                  value={annuallyprice}
                  onChange={(event) => {
                    setAnnuallypriceError("");
                    setAnnuallyprice(event.target.value.replace(/\D/g, ""));
                  }}
                />
                {annuallypriceError.length > 0 && (
                  <span style={{ color: "red", marginLeft: 6 }}>
                    {annuallypriceError}
                  </span>
                )}
              </div> */}

              <div className="col-xl-6 col-lg-6">
                <label htmlFor="exampleInputEmail1">
                  <h5 className="mb-0">Dynamic QrCode Count</h5>
                </label>
                <input
                  disabled={isdisabled}
                  type="text"
                  maxlength="20"
                  className="form-control mb-2"
                  placeholder="Please Enter Dynamic QrCode Count"
                  value={dynamicQrCodeCount}
                  onChange={(event) => {
                    setDynamicQrCodeCountError("");
                    setDynamicQrCodeCount(event.target.value);
                  }}
                />
                {/* <p
                  style={{
                    fontSize: 12,
                    color: "red",
                    marginTop: "7px",
                    marginLeft: "10px",
                  }}
                >
                  {dynamicQrCodeCount?.length}/20
                </p> */}
                {dynamicQrCodeCountError.length > 0 && (
                  <span style={{ color: "red", marginLeft: 6 }}>
                    {dynamicQrCodeCountError}
                  </span>
                )}
              </div>

              {
                IsWeb ?
                  <div className="col-xl-6 col-lg-6">
                    <label htmlFor="exampleInputEmail1">
                      <h5 className="mb-0">Bulk QrCode Count</h5>
                    </label>
                    <input
                      disabled={isdisabled}
                      type="text"
                      maxlength="20"
                      className="form-control mb-2"
                      placeholder="Please Enter Bulk QrCode"
                      value={bulkQrCodeCount}
                      onChange={(event) => {
                        setBulkQrCodeCountError("");
                        setbulkQrCodeCount(event.target.value);
                      }}
                    />
                    {/* <p
                  style={{
                    fontSize: 12,
                    color: "red",
                    marginTop: "7px",
                    marginLeft: "10px",
                  }}
                >
                  {bulkQrCodeCount?.length}/20
                </p> */}
                    {bulkQrCodeCountError.length > 0 && (
                      <span style={{ color: "red", marginLeft: 6 }}>
                        {bulkQrCodeCountError}
                      </span>
                    )}
                  </div>
                  :
                  <>
                  </>
              }
              {
                IsWeb ?
                  <div className="col-xl-6 col-lg-6">
                    <label htmlFor="exampleInputEmail1">
                      <h5 className="mb-0">Sub Account Count</h5>
                    </label>
                    <input
                      disabled={isdisabled}
                      type="text"
                      maxlength="20"
                      className="form-control mb-2"
                      placeholder="Please Enter Sub Account Count"
                      value={subaccountCount}
                      onChange={(event) => {
                        setSubaccountCountError("");
                        setSubaccountCount(event.target.value);
                      }}
                    />
                    {/* <p
                  style={{
                    fontSize: 12,
                    color: "red",
                    marginTop: "7px",
                    marginLeft: "10px",
                  }}
                >
                  {subaccountCount?.length}/20
                </p> */}
                    {subaccountCountError.length > 0 && (
                      <span style={{ color: "red", marginLeft: 6 }}>
                        {subaccountCountError}
                      </span>
                    )}
                  </div>
                  :
                  <>
                  </>
              }
              <div className="col-xl-6 col-lg-6">
                <label htmlFor="exampleInputEmail1">
                  <h5 className="mb-0">Data Storage Count</h5>
                </label>
                <NumericFormat
                  disabled={isdisabled}
                  thousandSeparator={true}
                  className="form-control mb-2"
                  placeholder={"Please Enter Data Storage Count only GB value"}
                  decimalScale={2}
                  fixedDecimalScale={false}
                  value={dataStorageCount}
                  onValueChange={(e) => {
                    setDataStorageCount(e.floatValue)
                  }}
                />
                {/* <input
                  type="text"
                  maxlength="15"
                  disabled={isdisabled}
                  className="form-control mb-2"
                  placeholder="Please Enter Data Storage Count only bytes value"
                  value={dataStorageCount}
                  onChange={(event) => {
                    setDataStorageCountError("");
                    if(event.target.value){
                    setDataStorageCount(parseFloat(event.target.value).toFixed(2));
                    }
                    else{
                      setDataStorageCount("");
                    }
                  }}
                /> */}
                {/* <p
                  style={{
                    fontSize: 12,
                    color: "red",
                    marginTop: "7px",
                    marginLeft: "10px",
                  }}
                >
                  {dataStorageCount?.length}/15
                </p> */}
                {dataStorageCountError.length > 0 && (
                  <span style={{ color: "red", marginLeft: 6 }}>
                    {dataStorageCountError}
                  </span>
                )}
              </div>
              {
                IsWeb ?
                  <div className="col-xl-6 col-lg-6">
                    <label htmlFor="exampleInputEmail1">
                      <h5 className="mb-0">Static QrCode Count</h5>
                    </label>
                    <input
                      disabled={isdisabled}
                      type="text"
                      maxlength="20"
                      className="form-control mb-2"
                      placeholder="Please Enter Static QrCode Count"
                      value={staticCodeCount}
                      onChange={(event) => {
                        setStaticCodeCountError("");
                        setStaticCodeCount(event.target.value);
                      }}
                    />
                    {/* <p
                  style={{
                    fontSize: 12,
                    color: "red",
                    marginTop: "7px",
                    marginLeft: "10px",
                  }}
                >
                  {staticCodeCount?.length}/20
                </p> */}
                    {staticCodeCountError.length > 0 && (
                      <span style={{ color: "red", marginLeft: 6 }}>
                        {staticCodeCountError}
                      </span>
                    )}
                  </div>
                  :
                  <>
                  </>
              }
              {
                IsWeb ?
                  <div className="col-xl-6 col-lg-6">
                    <label htmlFor="exampleInputEmail1">
                      <h5 className="mb-0">Parsonal Dynamic QrCode Count</h5>
                    </label>
                    <input
                      disabled={isdisabled}
                      type="text"
                      maxlength="20"
                      className="form-control mb-2"
                      placeholder="Please Enter Parsonal Dynamic QrCode Count"
                      value={personaldynamicQrCodeCount}
                      onChange={(event) => {
                        setPersonaldynamicQrCodeCountError("");
                        setPersonaldynamicQrCodeCount(event.target.value);
                      }}
                    />
                    {/* <p
                  style={{
                    fontSize: 12,
                    color: "red",
                    marginTop: "7px",
                    marginLeft: "10px",
                  }}
                >
                  {personaldynamicQrCodeCount?.length}/20
                </p> */}
                    {personaldynamicQrCodeCountError.length > 0 && (
                      <span style={{ color: "red", marginLeft: 6 }}>
                        {personaldynamicQrCodeCountError}
                      </span>
                    )}
                  </div>
                  :
                  <>
                  </>
              }

              {/* <div className="col-xl-6 col-lg-6">
                <label htmlFor="exampleInputEmail1">
                  <h5 className="mb-0">Package</h5>
                </label>
                <div className="searchForm">
                  <select
                    className="default-select2 form-control"
                    onChange={(e) => {
                      setselectpackageYearly(e.target.value);
                    }}
                  >
                    <option
                      value="true"
                      selected={selectpackageYearly === "true"}
                    >
                      Monthly
                    </option>
                    <option
                      value="false"
                      selected={selectpackageYearly === "false"}
                    >
                      Yearly
                    </option>
                  </select>
                </div>
              </div> */}


              {IsCustom === true ? (
                <div className="col-xl-4 col-lg-4">
                  <div className="mt-2">
                    <input
                      disabled={true}
                      type="checkbox"
                      value=""
                      id="IsCustom"
                      checked={IsCustom}
                    // onChange={(e) => {
                    //   setIsCustom(e.target.checked);
                    // }}
                    />
                    <label htmlFor="IsCustom" className="ml-2">
                      {" "}
                      Is Custom
                    </label>
                  </div>
                </div>
              ) : (
                <>
                </>
              )}
              {
                IsWeb ?
                  <div className="col-xl-4 col-lg-4">
                    <div className="mt-2">
                      <input
                        disabled={isdisabled}
                        type="checkbox"
                        value=""
                        id="IsChatEnabled"
                        checked={ChatEnabled}
                        onChange={(e) => {
                          setChatEnabled(e.target.checked);
                        }}
                      />
                      <label htmlFor="IsChatEnabled" className="ml-2">
                        {" "}
                        Chat Enabled
                      </label>
                    </div>
                  </div>
                  : <></>
              }
              {
                IsWeb ?
                  <div className="col-xl-4 col-lg-4">
                    <div className="mt-2">
                      <input
                        disabled={isdisabled}
                        type="checkbox"
                        value=""
                        id="IsAutoRenewal"
                        checked={AutoRenewal}
                        onChange={(e) => {
                          setAutoRenewal(e.target.checked);
                        }}
                      />
                      <label htmlFor="IsAutoRenewal" className="ml-2">
                        {" "}
                        Auto Renewal
                      </label>
                    </div>
                  </div>
                  : <></>
              }
              {
                IsWeb ?
                  <div className="col-xl-4 col-lg-4">
                    <div className="mt-2">
                      <input
                        disabled={isdisabled}
                        type="checkbox"
                        value=""
                        id="IsSSLCertificate"
                        checked={SSLCertificate}
                        onChange={(e) => {
                          setSSLCertificate(e.target.checked);
                        }}
                      />
                      <label htmlFor="IsSSLCertificate" className="ml-2">
                        {" "}
                        SSL Certificate
                      </label>
                    </div>
                  </div>
                  : <></>
              }
              {
                IsWeb ?
                  <div className="col-xl-4 col-lg-4">
                    <div className="mt-2">
                      <input
                        disabled={isdisabled}
                        type="checkbox"
                        value=""
                        id="IsAdvanceQrCodeSearch"
                        checked={AdvanceQrCodeSearch}
                        onChange={(e) => {
                          setAdvanceQrCodeSearch(e.target.checked);
                        }}
                      />
                      <label htmlFor="IsAdvanceQrCodeSearch" className="ml-2">
                        {" "}
                        Advance QrCode Search
                      </label>
                    </div>
                  </div>
                  : <></>
              }
              {
                IsWeb ?
                  <div className="col-xl-4 col-lg-4">
                    <div className="mt-2">
                      <input
                        disabled={isdisabled}
                        type="checkbox"
                        value=""
                        id="IsQrCodeSaveInWallet"
                        checked={QrCodeSaveInWallet}
                        onChange={(e) => {
                          setQrCodeSaveInWallet(e.target.checked);
                        }}
                      />
                      <label htmlFor="IsQrCodeSaveInWallet" className="ml-2">
                        {" "}
                        QrCode Save In Wallet
                      </label>
                    </div>
                  </div>
                  : <></>
              }
              {
                IsWeb ?
                  <div className="col-xl-4 col-lg-4">
                    <div className="mt-2">
                      <input
                        disabled={isdisabled}
                        type="checkbox"
                        value=""
                        id="IsQrCodeCategoryManaged"
                        checked={QrCodeCategoryManaged}
                        onChange={(e) => {
                          setQrCodeCategoryManaged(e.target.checked);
                        }}
                      />
                      <label htmlFor="IsQrCodeCategoryManaged" className="ml-2">
                        {" "}
                        QrCode Category Managed
                      </label>
                    </div>
                  </div>
                  : <></>
              }
              {
                IsWeb ?
                  <div className="col-xl-4 col-lg-4">
                    <div className="mt-2">
                      <input
                        disabled={isdisabled}
                        type="checkbox"
                        value=""
                        id="IsExportQrCode"
                        checked={ExportQrCode}
                        onChange={(e) => {
                          setExportQrCode(e.target.checked);
                        }}
                      />
                      <label htmlFor="IsExportQrCode" className="ml-2">
                        {" "}
                        Export QrCode
                      </label>
                    </div>
                  </div>
                  : <></>
              }
              {
                IsWeb ?
                  <div className="col-xl-4 col-lg-4">
                    <div className="mt-2">
                      <input
                        disabled={isdisabled}
                        type="checkbox"
                        value=""
                        id="IsEmailSupport"
                        checked={EmailSupport}
                        onChange={(e) => {
                          setEmailSupport(e.target.checked);
                        }}
                      />
                      <label htmlFor="IsEmailSupport" className="ml-2">
                        {" "}
                        Email Support
                      </label>
                    </div>
                  </div>
                  : <></>
              }
              {
                IsWeb ?
                  <div className="col-xl-4 col-lg-4">
                    <div className="mt-2">
                      <input
                        disabled={isdisabled}
                        type="checkbox"
                        value=""
                        id="IsIndividualSupport"
                        checked={IndividualSupport}
                        onChange={(e) => {
                          setIndividualSupport(e.target.checked);
                        }}
                      />
                      <label htmlFor="IsIndividualSupport" className="ml-2">
                        {" "}
                        Individual Support
                      </label>
                    </div>
                  </div>
                  : <></>
              }
              {
                IsWeb ?
                  <div className="col-xl-4 col-lg-4">
                    <div className="mt-2">
                      <input
                        disabled={isdisabled}
                        type="checkbox"
                        value=""
                        id="IndividualPhoneSupport"
                        checked={IndividualPhoneSupport}
                        onChange={(e) => {
                          setIndividualPhoneSupport(e.target.checked);
                        }}
                      />
                      <label htmlFor="IsIndividualPhoneSupport" className="ml-2">
                        {" "}
                        Individual Phone Support
                      </label>
                    </div>
                  </div>
                  : <></>
              }
              {
                IsWeb ?
                  <div className="col-xl-4 col-lg-4">
                    <div className="mt-2">
                      <input
                        disabled={isdisabled}
                        type="checkbox"
                        value=""
                        id="IsWhiteLabelling"
                        checked={WhiteLabelling}
                        onChange={(e) => {
                          setWhiteLabelling(e.target.checked);
                        }}
                      />
                      <label htmlFor="IsWhiteLabelling" className="ml-2">
                        {" "}
                        Tag Line
                      </label>
                    </div>
                  </div>
                  : <></>
              }
              {
                IsWeb ?
                  <div className="col-xl-4 col-lg-4">
                    <div className="mt-2">
                      <input
                        disabled={isdisabled}
                        type="checkbox"
                        value=""
                        id="IsYourBranding"
                        checked={YourBranding}
                        onChange={(e) => {
                          setYourBranding(e.target.checked);
                        }}
                      />
                      <label htmlFor="IsYourBranding" className="ml-2">
                        {" "}
                        Your Branding
                      </label>
                    </div>
                  </div>
                  : <></>
              }
            </div>
          </div>

          <div className="d-flex justify-content-center">
            <button
              type="button"
              className="btn btn-sm btn-primary m-r-5 shadow-add"
              onClick={() => {
                submitSystempackage();
              }}
            >
              {SystempackageID.length === 0 ? "Create" : "Update"}
            </button>
            <button
              className="btn btn-sm btn-danger shadow-add "
              onClick={() => {
                toggleQrCodeModal();
              }}
            >
              Cancel
            </button>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}

export default Package;
